//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Apfel",
  data() {
    return {
      form: {
        women :'0',
        smoke:'0',
        ponv: "0",
        drug: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  filters:{
    handleSore(val) {
      switch (val) {
        case 0:
          return '10'
          case 1:
          return '20'

          case 2:
          return '40'
          case 3:
          return '60'

          case 4:
          return '80'

        default:
          break;
      }
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      console.log(form,321);
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result +=Number(form[key])
      }
     
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
       
     
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Apfel.vue